export const getDisplayText = (
  options: any[],
  selected: any,
  labelAll: string,
  multipleLabel = 'Multiple'
) => {
  if (Array.isArray(selected)) {
    const values = selected.filter((v: any) => v);

    if (values.length > 1) return multipleLabel;
    if (values.length === 0) return labelAll;

    const targetOption = options.find(({ value }) => values[0] === value);
    return targetOption?.text || labelAll;
  }

  const values = String(selected)
    .split(',')
    .filter((v: any) => v);

  if (values.length > 1) return multipleLabel;
  if (values.length === 0) return labelAll;

  const targetOption = options.find(({ value }) => values[0] === String(value));
  return targetOption?.text || labelAll;
};
